import IMask from "imask";

document.addEventListener("DOMContentLoaded", () => {
  const phones = document.querySelectorAll("[data-phone]");
  [].forEach.call(phones, (phone) => {
    if (!phone.placeholder) {
      phone.placeholder = "+7 (___) ___-__-__";
    }
    const maskOptions = {
      mask: "+{7} (000) 000-00-00",
      // Keep the editable value empty so IMask 7 accepts a complete formatted
      // phone number on paste or replacement; the visual hint lives above.
      lazy: true,
    };
    const mask = new IMask(phone, maskOptions);
  });
});
